import { ChakraProvider } from '@chakra-ui/react';
import type { ComponentType } from 'react';
import { Route, Routes } from 'react-router-dom';
import HomePage from '@/travo/pages/home/HomePage';
import AboutPage from '@/travo/pages/about/AboutPage';
import LegalPage from '@/travo/pages/legal/LegalPage';
import NotFoundPage from '@/travo/pages/notFound/NotFoundPage';
import TravoLayout from '@/travo/components/layout/TravoLayout';
import { LOCALES, localizePath, TRAVO_BASE } from '@/travo/i18n';
import { PAGE_PATHS, ROUTES, type PagePath } from '@/travo/routes';
import { system } from '@/travo/theme/theme';
import { localizedRoutes } from '@/shared/localizedRoutes';

const TravoPrivacyPage = () => <LegalPage kind="privacy" />;
const TravoTermsPage = () => <LegalPage kind="terms" />;

/** One component per page path; the Record type makes a new PAGE_PATHS entry need one. */
const PAGE_COMPONENTS: Record<PagePath, ComponentType> = {
  [ROUTES.home]: HomePage,
  [ROUTES.about]: AboutPage,
  [ROUTES.privacy]: TravoPrivacyPage,
  [ROUTES.terms]: TravoTermsPage
};

/** Everything under /travo: every page in every locale inside TravoLayout and the Chakra theme, plus Travo's 404. */
const TravoSection = () => (
  <ChakraProvider value={system}>
    <Routes>
      <Route element={<TravoLayout />}>
        {localizedRoutes({
          locales: LOCALES,
          pages: PAGE_PATHS,
          components: PAGE_COMPONENTS,
          pathFor: localizePath,
          base: TRAVO_BASE
        })}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  </ChakraProvider>
);

export default TravoSection;
